module.exports = __webpack_public_path__ + "static/media/sidebar_image.682556d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar_image.png
// module id = 7582
// module chunks = 0